module.exports = __webpack_public_path__ + "img/Logo-18.5ef48dea.svg";